import React from 'react'
import styled from 'styled-components'

interface Props extends React.HTMLAttributes<HTMLTableCellElement> {
    children: React.ReactNode | React.ReactNode[];
    onClick?: () => void;
    minWidth?: string;
    isSticky?: boolean;
    index?: number;
}

const TableHeadCell = ({
    children, onClick, minWidth, isSticky, index, ...props
}: Props) => {
  return (
    <TableHeadCellStyle
      $isClickAllow={!!onClick}
      onClick={onClick}
      $minWidth={minWidth}
      $isSticky={isSticky}
      $indexExternal={index}
      
      {...props}
    >
        {children}
    </TableHeadCellStyle>
  )
}
const TableHeadCellStyle = styled.th<{$isClickAllow?: boolean, $minWidth?: string, $isSticky?: boolean, $indexExternal?: number}>`
    min-width: ${props => props.$minWidth ? props.$minWidth : '60px'};
    height: 1em;
    border-radius: 15px 15px 0 0;
    padding: 0.2em 0.6em;
    background: #81B4AF;
    color: #fff;
    white-space: nowrap;
    
    cursor: ${props => props.$isClickAllow ? 'pointer' : 'default'};
    // Добавляем sticky позиционирование для первого столбца
    ${props => props.$isSticky && `
        position: sticky;
        right: 0;
        z-index: 1;
        box-shadow: -2px 0 5px rgba(0,0,0,0.1);
    `}
    ${props => props.$indexExternal && props.$indexExternal > 0 && `
        right: ${props.$indexExternal}99px;
    `}
   
`
export default TableHeadCell